import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer";
import { images } from "../../config/images";
import "../Division/div.css";
import { categoryData, productData, subcategory } from "../../config/services";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { slugify } from "../../utils/slugify";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";
import { NeuroShimmer } from "../../components/Shimmer/Shimmer";

const CustomPagination = styled(Pagination)(({ theme }) => ({
  "& .MuiPaginationItem-root": {
    borderColor: "var(--accent-color)",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: "30px",
  },
  "& .Mui-selected": {
    borderColor: "var(--accent-color)",
    backgroundColor: "var(--accent-color) !important",
    color: "var(--white) !important",
  },
}));

const Neuro = ({ headerAPIData }) => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const location = useLocation();
  const productId = location.state;

  const query = useQuery();
  const subcategoriesId = query.get("subcategories_id");

  const [subcategoryData, setSubCategoryData] = useState([]);
  const [subcategoryLoading, setSubcategoryLoading] = useState(false);
  const [catogoryId, setCategoryId] = useState(null);
  const [selectedTabId, setSelectedTabId] = useState(null);
  const [selectedTabName, setSelectedTabName] = useState(null);
  const [productAPIData, setProductAPIData] = useState([]);
  const [productLoading, setProductLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [matchedTab, setMatchedTab] = useState([]);
  const [resolvedCategoryName, setResolvedCategoryName] = useState('');
  useEffect(() => {
    if (
      subcategoryData?.length === 0 &&
      productAPIData?.length === 0 &&
      headerAPIData?.length === 0
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [subcategoryData, productAPIData, headerAPIData]);

  const param = useParams();

  const handlecategoryClick = async (e) => {
    setSelectedTabId(e.id);
    setCategoryId(e.category_id);
    setSelectedTabName(e.title);

    await fetchProductData(e.category_id, e.id, 1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    fetchProductData(catogoryId, selectedTabId, value);
  };

  useEffect(() => {
    setProductAPIData([]);
    setSelectedTabName(null);

    const resolveCategoryAndFetch = async () => {
      let categoryId = productId?.category_id;

      if (!categoryId) {
        try {
          const resp = await categoryData();
          if (resp.data.code === 200 || resp.data.code === 201) {
            const categories = resp.data.responseBody;
            const matched = categories.find(cat => slugify(cat.title) === param.categorySlug);
            if (matched) {
              categoryId = matched.id;
              setResolvedCategoryName(matched.title);
            }
          }
        } catch (error) {
          console.log("Error resolving category:", error);
          return;
        }
      } else {
        setResolvedCategoryName(productId?.navTitle || '');
      }

      if (categoryId) {
        handlesubcategory(categoryId);
      }
    };

    resolveCategoryAndFetch();
  }, [param.categorySlug]);

  useEffect(() => {
    if (
      subcategoryData?.subcategory &&
      subcategoryData?.subcategory.length > 0
    ) {
      // Check if subcategoriesId exists in the data
      const matchedTab = subcategoryData?.subcategory.find(
        (tab) => tab.id === Number(subcategoriesId)
      );
      setMatchedTab(matchedTab)
      if (matchedTab) {
        setSelectedTabId(matchedTab?.id);
        setCategoryId(matchedTab?.category_id);
        setSelectedTabName(matchedTab?.title);
        fetchProductData(matchedTab?.category_id, matchedTab?.id, currentPage);
      } else if (productId?.id) {
        setSelectedTabId(productId?.id);
        setCategoryId(productId?.category_id);
        setSelectedTabName(productId?.totle);
        fetchProductData(productId?.category_id, productId?.id, currentPage);
      } else {
        // Fallback to the first subcategory if no match is found
        const firstTab = subcategoryData?.subcategory[0];
        setSelectedTabId(firstTab?.id);
        setCategoryId(subcategoryData?.subcategory[0].category_id);
        setSelectedTabName(subcategoryData?.subcategory[0].title);
        subcategoryData &&
          fetchProductData(
            subcategoryData?.subcategory[0]?.category_id,
            subcategoryData?.subcategory[0]?.id,
            currentPage
          );
      }
    }
  }, [subcategoryData, subcategoriesId]);

  const fetchProductData = async (category_id, subcategory_id, page) => {
    const params = {
      categories_id: category_id,
      subcategories_id: subcategory_id,
    };

    try {
      setProductLoading(true);
      const resp = await productData(page, { params });
      if (resp.data.code === 200 || resp.data.code === 201) {
        setProductAPIData(resp.data.responseBody);
        setProductLoading(false);
      }
    } catch (error) {
      setProductAPIData([]);
      console.log("Error fetching product data:", error);
    }
  };

  const handlesubcategory = async (categoryId) => {
    const params = {
      id: categoryId,
    };

    try {
      setSubcategoryLoading(true);

      const resp = await subcategory({ params });
      if (resp.data.code === 200) {
        setSubCategoryData(resp.data.responseBody);
        setSubcategoryLoading(false);
      }
    } catch (error) {
      setSubCategoryData([]);
      console.log("handleSubcategory error:", error);
    }
  };

  const navigate = useNavigate();

  const handleProductClick = (product) => {
    navigate(`/division/${param.categorySlug}/${slugify(product.title)}`, {
      state: { productId: product.id }
    });
  };

  const breadcrumbsData = [
    { label: "Home", url: "/" },
    {
      label: "Division",
      url: `/division/${param.categorySlug}`,
    },
    {
      label: productId?.navTitle || resolvedCategoryName || matchedTab?.title,
      url: `/division/${param.categorySlug}`
    },
  ];

  useEffect(() => {
    const myTab = document.getElementById("myTab");
    let isDown = false;
    let startX;
    let scrollLeft;

    const mouseDownHandler = (e) => {
      isDown = true;
      myTab.classList.add("active");
      startX = e.pageX - myTab.offsetLeft;
      scrollLeft = myTab.scrollLeft;
    };

    const mouseLeaveHandler = () => {
      isDown = false;
      myTab.classList.remove("active");
    };

    const mouseUpHandler = () => {
      isDown = false;
      myTab.classList.remove("active");
    };

    const mouseMoveHandler = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - myTab.offsetLeft;
      const walk = (x - startX) * 2;
      myTab.scrollLeft = scrollLeft - walk;
    };

    myTab.addEventListener("mousedown", mouseDownHandler);
    myTab.addEventListener("mouseleave", mouseLeaveHandler);
    myTab.addEventListener("mouseup", mouseUpHandler);
    myTab.addEventListener("mousemove", mouseMoveHandler);

    // Cleanup the event listeners on component unmount
    return () => {
      myTab.removeEventListener("mousedown", mouseDownHandler);
      myTab.removeEventListener("mouseleave", mouseLeaveHandler);
      myTab.removeEventListener("mouseup", mouseUpHandler);
      myTab.removeEventListener("mousemove", mouseMoveHandler);
    };
  }, []);

  return (
    <div className="division-page-wrap">
      <div className="about-us-container mt-">
        <div className="molecule left">
          <img src={images.leftSpirrel} alt="" className="left-spinner" />
        </div>
        <div className="about-text">
          <h1>Division</h1>
          <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
        </div>
        <div className="molecule right">
          <img src={images.rightSpirrel} alt="" className="right-spinner" />
        </div>
      </div>

      <div className="container-fluid mt-4">
        <div className="division-title-div mt-5 ms-2 me-2">
          <h3 className="text-center mb-4 division-tittle mt-5 pt-2 pb-1">Our {productId?.navTitle || resolvedCategoryName} Segments</h3>
        </div>
        {/* <ul
          className=" nav nav-tabs justify-content-center mb-4"
          id="myTab"
          role="tablist"
          style={{
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "auto",
            whiteSpace: "nowrap",
            cursor: "grab",
            scrollbarWidth: "none",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {subcategoryLoading ? (
            <ul className="nav">
              {[1, 2, 3].map((_, index) => (
                <li className="nav-item shimmer-item-neuro" key={index}>
                  <div className="shimmer-placeholder-neuro shimmer-button-neuro"></div>
                </li>
              ))}
            </ul>
          ) : subcategoryData?.subcategory?.length > 0 ? (
            subcategoryData.subcategory.map((tab) => (
              <li className="nav-item" role="presentation" key={tab.id}>
                <button
                  className={`nav-link division-tab-link ${
                    selectedTabId === tab.id ? "active-class-data" : ""
                  }`}
                  onClick={() => handlecategoryClick(tab)}
                >
                  {tab.title}
                </button>
              </li>
            ))
          ) : (
            <div className="text-center w-100">
              <h2 style={{ fontSize: "1rem" }}>Data Not Found</h2>
            </div>
          )}
        </ul> */}

        <div style={{ overflow: "hidden", padding: "0 10px" }}>
          <ul
            className=" container nav nav-tabs justify-content-center mb-4"
            id="myTab"
            role="tablist"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center"
            }}
            onWheel={(e) => {
              e.preventDefault();
              e.currentTarget.scrollLeft += e.deltaY;
            }}
          >
            {subcategoryLoading ? (
              <div className="nav">
                {[1, 2, 3].map((_, index) => (
                  <li className="nav-item shimmer-item-neuro" key={index}>
                    <div className="shimmer-placeholder-neuro shimmer-button-neuro"></div>
                  </li>
                ))}
              </div>
            ) : subcategoryData?.subcategory?.length > 0 ? (
              subcategoryData.subcategory.map((tab) => (
                <li className="nav-item" role="presentation" key={tab.id}>
                  <button
                    className={`nav-link division-tab-link ${selectedTabId === tab.id ? "active-class-data" : ""
                      }`}
                    onClick={() => handlecategoryClick(tab)}
                  >
                    {tab.title}
                  </button>
                </li>
              ))
            ) : (
              <li className="nav-item" style={{ width: "100%", listStyle: "none" }}>
                <div className="neuro-segments-not-found">
                  <div className="neuro-data-not-found" role="status" aria-live="polite">
                    <div className="neuro-data-not-found-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="12" y1="18" x2="12" y2="12" />
                        <line x1="9" y1="15" x2="15" y2="15" />
                      </svg>
                    </div>
                    <h3>Data not found</h3>
                    <p>No segments are available for this category. Please try again later or contact support.</p>
                  </div>
                </div>
              </li>
            )}
          </ul>
        </div>



        {subcategoryLoading ? (
          <>
            <div className="tab-content" id="myTabContent">
              <div className="container mt-5 ">
                <div className="shimmer-placeholder-neuro neuro-section-title-shimmer" />
                <Grid container spacing={3} className="neuro-product-grid">
                  <NeuroShimmer count={4} />
                </Grid>
              </div>
            </div>
          </>
        ) : (
          subcategoryData?.subcategory?.length > 0 && (
            <div className="tab-content" id="myTabContent">
              <div className="container mt-5 ">
                <h3 className="text-center mb-4 product-tittle mt-3">
                  {selectedTabName}
                </h3>
                <Grid container spacing={3} className="neuro-product-grid">
                  {productLoading ?
                    <NeuroShimmer count={4} />
                    : productAPIData?.data?.length > 0 ? (
                      productAPIData.data.map((product, index) => {
                        const title = product.title || "";
                        const hyphenIndex = title.indexOf("-");
                        const titleBase = hyphenIndex > 0 ? title.slice(0, hyphenIndex).trim() : title;
                        const titleSuffix = hyphenIndex > 0 ? title.slice(hyphenIndex).trim() : "";
                        return (
                          <Grid item xs={12} sm={6} md={3} key={product.id ?? index}>
                            <Box
                              className="neuro-product-card"
                              onClick={() => handleProductClick(product)}
                            >
                              <div className="neuro-product-img-wrap">
                                <img
                                  src={product.image}
                                  alt={product.title || `Product ${index + 1}`}
                                />
                              </div>
                              <h5 className="neuro-product-title">
                                <span className="title-base">{titleBase || title || `Product ${index + 1}`}</span>
                                {titleSuffix ? <span className="title-suffix"> {titleSuffix}</span> : null}
                              </h5>
                            </Box>
                          </Grid>
                        );
                      })
                    ) : (
                      <Grid item xs={12}>
                        <div className="neuro-data-not-found" role="status" aria-live="polite">
                          <div className="neuro-data-not-found-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline points="14 2 14 8 20 8" />
                              <line x1="12" y1="18" x2="12" y2="12" />
                              <line x1="9" y1="15" x2="15" y2="15" />
                            </svg>
                          </div>
                          <h3>No products found</h3>
                          <p>There are no products available in this segment at the moment. Please try another segment or check back later.</p>
                        </div>
                      </Grid>
                    )}
                </Grid>

                {productAPIData && productAPIData.total > 0 && (
                  <Box className="neuro-pagination-wrap" display="flex" justifyContent="center" alignItems="center">
                    <Stack spacing={2}>
                      <CustomPagination
                        count={Math.ceil(
                          productAPIData.total / productAPIData.per_page
                        )}
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        color="primary"
                      />
                    </Stack>
                  </Box>
                )}
              </div>
            </div>
          )
        )}
      </div>
      {isLoading ? <FullpageLoader /> : null}
    </div>
  );
};

export default Neuro;
